import { render } from "./SingleSectionDetailModal.vue?vue&type=template&id=5a5ac58f"
import script from "./SingleSectionDetailModal.vue?vue&type=script&lang=js"
export * from "./SingleSectionDetailModal.vue?vue&type=script&lang=js"

import exportComponent from "E:\\wamp64\\www\\law-firm-system-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__